import {Component, ChangeDetectionStrategy, input} from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class CardComponent {
  readonly noMarginLeft = input<boolean>(false);

}
